/**
 * Auth cookie names for the Passenger app.
 *
 * Namespaced per-app so the three TMS front-ends (web / driver / passenger) do
 * not clobber each other's session when served on the same host (cookies are
 * not scoped by port — see ADR 0049). Web keeps the bare `__session` names.
 */
export const ACCESS_COOKIE = "__pax_session";
export const REFRESH_COOKIE = "__pax_session_refresh";

/**
 * No-login contract guest (FT-PA-001) — set after scanning a contract QR.
 * Separate from the booking app's session above: it belongs to no account, and
 * it is httpOnly because only the server-side route handlers ever send it on
 * (the browser never needs to read it), which also keeps the whole guest flow
 * same-origin so a phone only has to reach one host.
 */
export const GUEST_COOKIE = "__pax_guest";
